import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { LoadingState } from '@tsin-core/entities';
import { ExamFeeService } from '@tsin-core/services/http/exam-fee.service';
import { CreateExamFee, GetAllExamFees, GetExamFeesByType, UpdateExamFees } from './exam-fees.action';
import { catchError, tap, throwError } from 'rxjs';
import { IExamFee } from '@tsin-core/models/exam-fee.model';

export interface ExamFeeStateModel {
  examFees: IExamFee[];
  loading: LoadingState;
}

@State<ExamFeeStateModel>({
  name: 'examFeeState',
  defaults: {
    examFees: [],
    loading: LoadingState.notLoading,
  },
})
@Injectable()
export class ExamFeeState {
  examFeeService: ExamFeeService = inject(ExamFeeService);

  @Selector()
  static listExamFees(state: ExamFeeStateModel): IExamFee[] {
    console.log('Current state', state.examFees)
    return state.examFees ?? [];
  }

  @Selector()
  static getLoading(state: ExamFeeStateModel): LoadingState {
    return state.loading;
  }

  @Action(CreateExamFee)
  createExamFee(ctx: StateContext<ExamFeeStateModel>, action: CreateExamFee) {
    ctx.patchState({ loading: LoadingState.loadingAddUpdate });
    return this.examFeeService.createExamFee(action.payload).pipe(
      tap((newExamFeeData: { data: IExamFee }) => {
        const state = ctx.getState();
        const newExamFee = newExamFeeData.data;
        console.log('the new value', newExamFee)
        ctx.patchState({
          examFees: [...state.examFees, { ...newExamFee }],
          loading: LoadingState.notLoading,
        });
        console.log('Updated State:', ctx.getState());
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }

  @Action(UpdateExamFees)
  updateExamFee(ctx: StateContext<ExamFeeStateModel>, action: UpdateExamFees) {
    ctx.patchState({ loading: LoadingState.loadingAddUpdate });
    return this.examFeeService.updateExamFee(action.payload).pipe(
      tap((updateExamFeeData: { data: IExamFee }) => {
        const state = ctx.getState();
        const updateExamFee = updateExamFeeData.data;
        const updatedExamFee: any = state.examFees.map((examFees) => {
          examFees.id === updateExamFee.id ? updatedExamFee : examFees
        })
        ctx.patchState({
          examFees: updatedExamFee,
          loading: LoadingState.notLoading
        })
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        return throwError(() => error);
      })
    )
  }

  @Action(GetAllExamFees)
  getExamFees(ctx: StateContext<ExamFeeStateModel>, action: GetAllExamFees) {
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.examFeeService.getExamFee().pipe(
      tap((examFees: any[]) => {
        ctx.patchState({ examFees, loading: LoadingState.notLoading });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    )
  }

  @Action(GetExamFeesByType)
  getExamFeeByType(ctx: StateContext<ExamFeeStateModel>, action: GetExamFeesByType) {
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.examFeeService.getExamFeeByType(action.examType).pipe(
      tap((examFees: { data: IExamFee[] }) => {
        ctx.patchState({ examFees: examFees.data, loading: LoadingState.notLoading });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    )
  }


}
